import { useMutateOnRefresh } from '@va/dashboard/util-hooks';
import { useNumberOfVisitsByHour } from './apiClient';
import TrafficChartCard from './TrafficChartCard';

const VisitsByHourChart = () => {
  const { data, isLoading, mutate } = useNumberOfVisitsByHour();

  const { isManualRefreshing } = useMutateOnRefresh(mutate);

  return <TrafficChartCard baseKey='trafficPageLoadsByHour' data={data} isLoading={isLoading || isManualRefreshing} />;
};

export default VisitsByHourChart;
